import { produce } from 'immer';
import { over, lensPath, mergeLeft } from 'ramda';

import * as helpers from '../helpers';
import * as actions from './actions';

export const defaultState = {
    enabled: true,
    popups: {}, // all popups
    layerIds: [], // ordered layer Ids
    layers: {}, // ordered popup ids in each layer { [layerId]: [...] }
    layersMeta: {} // layers metadata. { [layerId]: { activePopupIndex, hideBelow, disableNavigation } }
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case actions.ADD_POPUP: {
            const state = helpers.addPopupOperation(draftState, action, defaultState);

            Object.assign(draftState, {
                ...state
            });

            break;
        }

        case actions.CLOSE_POPUP: {
            const { id } = action.payload;

            const state = helpers.closePopup(draftState, id);

            Object.assign(draftState, {
                ...state
            });

            break;
        }

        case actions.CLOSE_POPUPS: {
            const state = helpers.closePopups(draftState, action.payload, defaultState);

            Object.assign(draftState, {
                ...state
            });

            break;
        }

        case actions.NAV_PREV: {
            helpers.navigate(draftState, { isForward: false });

            break;
        }

        case actions.NAV_NEXT: {
            helpers.navigate(draftState, { isForward: true });

            break;
        }

        case actions.NAV_BY_INDEX: {
            const { index } = action.payload;

            helpers.navigate(draftState, { index });

            break;
        }

        case actions.UPDATE_POPUP: {
            const { id, ...data } = action.payload;
            const popup = draftState.popups[id];

            if (!popup) {
                break;
            }

            const state = over(
                lensPath(['popups', id]),
                mergeLeft(data)
            )(draftState);

            Object.assign(draftState, {
                ...state
            });

            break;
        }

        case actions.DISABLE_POPUPS: {
            Object.assign(draftState, {
                enabled: false
            });

            break;
        }

        case actions.ENABLE_POPUPS: {
            Object.assign(draftState, {
                enabled: true
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
